import type { DeepPartial } from '../../default/types';
import type { OrderConfig } from '../../default/order/order.types';
import { riskIdentSnippet } from '../../default/order/order';

export const orderConfig: DeepPartial<OrderConfig> = {
  paymentMethods: ['paypal', 'mastercard', 'visa', 'diners', 'discover'],
  hasCo2Compensation: false,
  externalUrls: {
    flexikontoPaymentPause: {
      default: '/service-hilfe/bezahlung-finanzierung/flexikonto-zahlpause',
    },
  },
  premium: {
    enabled: true,
    hasRuntimeOptions: false,
    hasLegalFooter: true,
  },
  newsletterCmsPage: {
    default: 'service-hilfe/newsletter/anmelden',
    'fr-CH': 'aide-service/newsletter/inscription',
  },
  paylink: {
    paymentMethods: ['mastercard', 'visa', 'diners', 'discover'],
  },
  riskIdent: {
    enabled: true,
    snippetId: riskIdentSnippet('ewUX1L'),
  },
  sovendus: {
    de: {
      trafficSourceNumber: '2229',
      trafficMediumNumber: { default: '3', mobile: '19', app: '30' },
    },
    fr: {
      trafficSourceNumber: '2230',
      trafficMediumNumber: { default: '2', mobile: '9', app: '22' },
    },
  },
};
